import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const configured = Boolean(url && anonKey);
export const supabase = configured ? createClient(url, anonKey) : null;
